import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import React from 'react';
import { useDispatch } from 'react-redux';

import { baseTheme } from '../../../theme';
import { loadGroupMembers } from '../../../store';

import { GroupMemberListItem } from '../index';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    publicGroup: {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
    privateGroup: {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.main,
    },
    centerText: {
      marginTop: 'auto',
      marginBottom: 'auto',
      fontWeight: 'bold',
    },
    memberPadding: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
    },
    borderBottomPrimary: {
      borderBottom: `solid 1px ${theme.palette.primary.main}`,
      marginBottom: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    borderBottomSecondary: {
      borderBottom: `solid 1px ${theme.palette.secondary.main}`,
      marginBottom: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    alignTextCenter: {
      textAlign: 'center',
    },
  }),
);

export function GroupMemberList(props: any) {
  const { group, handleIconClick } = props;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();

  const getGroupClass =
    (type: string) => type === 'Public'
      ? classes.publicGroup
      : classes.privateGroup;

  const onExpanded = (groupId: string) => (event: any, expanded: boolean) => {
    if (expanded) {
      loadGroupMembers(groupId, dispatch);
    }
  };

  return (
    <Grid item xs={12}>
      <Accordion
        classes={{
          root: getGroupClass(group.type),
        }}
        TransitionProps={{ unmountOnExit: true }}
        onChange={onExpanded(group.id)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon classes={{ root: getGroupClass(group.type) }} />}
          aria-controls="groupId-content"
          id="groupId-Header"
        >
          <IconButton
            color={group.type === 'Public' ? 'primary' : 'secondary'}
            onClick={handleIconClick(group)}
          >
            <MoreVertIcon />
          </IconButton>

          <Typography className={classes.centerText} >{group.name} - {group.type}</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Grid item container xs={12} className={classes.memberPadding}>

            <Grid
              item
              container
              xs={12}
              spacing={2}
              className={group.type === 'Public'
                ? classes.borderBottomPrimary
                : classes.borderBottomSecondary}
            >
              <Grid item xs={10}>Member Name</Grid>
              <Grid item xs={1} className={classes.alignTextCenter}>Date Joined</Grid>
              <Grid item xs={1}></Grid>
            </Grid>

            {
              group.members
                .map((member: any) => {
                  return (<GroupMemberListItem
                    color={group.type === 'Closed'
                      ? 'secondary'
                      : 'primary'}
                    key={member.id}
                    member={member}
                    group={group}
                  />);
                })
            }
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
